module.exports = __webpack_public_path__ + "static/img/sec1-detail01@w.4b52feb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pantos/sec1-detail01@w.png
// module id = +I14
// module chunks = 0